import {Icon} from '@wandb/components';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import React, {useCallback} from 'react';

import {
  NotebookPermission,
  useNotebookPermissionsQuery,
} from '../../generated/graphql';
import {useOpenMarimoNotebookRuntime} from '../../routes/notebooks/useOpenMarimoNotebookRuntime';
import {trackMarimoClickViewNotebook} from '../../services/analytics/productEvents';
import type * as PanelTypes from '../../state/views/panel/types';
import {useRampFlagMarimoNotebooks} from '../../util/rampFeatureFlags/rampFeatureFlags';
import {usePanelNotebookID} from './notebookIDSelector';

function PanelViewSourceDropdownItemInner({notebookId}: {notebookId: string}) {
  const openNotebookRuntime = useOpenMarimoNotebookRuntime();

  const onClick = useCallback(() => {
    trackMarimoClickViewNotebook({notebookId, source: 'header'});
    openNotebookRuntime(notebookId, undefined, {newTab: true});
  }, [notebookId, openNotebookRuntime]);

  return (
    <>
      <DropdownMenu.Item onSelect={onClick}>
        <Icon icon="code-alt" />
        View source notebook
      </DropdownMenu.Item>
      <DropdownMenu.Separator />
    </>
  );
}

export function PanelViewSourceDropdownItem({
  panelRef,
}: {
  panelRef: PanelTypes.Ref;
}) {
  const notebookId = usePanelNotebookID(panelRef);
  const isRuntimeEnabled = useRampFlagMarimoNotebooks();
  const {data} = useNotebookPermissionsQuery({
    variables: {id: notebookId ?? ''},
    skip: !notebookId,
  });

  if (
    !isRuntimeEnabled ||
    !notebookId ||
    !data?.notebook?.viewerPermissions.includes(NotebookPermission.Edit)
  ) {
    return null;
  }

  return <PanelViewSourceDropdownItemInner notebookId={notebookId} />;
}
